export default __webpack_public_path__ + "static/media/earlySubscriberAndroid_6.2de6bf91.svg";